const UpdateDescr = () => {
    return `No info about this Character`
}



export default UpdateDescr;